import { render } from "./inventarioTienda.vue?vue&type=template&id=6966fb5d&scoped=true"
import script from "./inventarioTienda.vue?vue&type=script&lang=js"
export * from "./inventarioTienda.vue?vue&type=script&lang=js"

import "./inventarioTienda.vue?vue&type=style&index=0&id=6966fb5d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6966fb5d"]])

export default __exports__